import { MIcon } from '../../components/@material-extend';

export default function Select() {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: () => <MIcon icon="keyboard_arrow_down" fontSize={20} sx={{ mr: 1 }} />
      },

      styleOverrides: {
        root: {
          '.MuiSelect-outlined': {}
        }
      }
    }
  };
}
